module.exports = __webpack_public_path__ + "static/css-versicherung-0bf93bc43cce7d7a32747212af7fda0a.svg";